var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 45,
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FDBE36",
    d: "M35 16.567C35 29.853 17.5 45 17.5 45S0 29.853 0 16.567C0 7.417 7.836 0 17.5 0 27.165 0 35 7.417 35 16.567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6F6F6",
    d: "M23 17.5a6.501 6.501 0 1 1-13.002-.002A6.501 6.501 0 0 1 23 17.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8ac7f9cc.svg";
export { ForwardRef as ReactComponent };